<script>
    import { onMount } from "svelte";

    let container;
    let wrapper;
    let slideCount;
    export let activeSlide = 0;
    let containerWidth;
    let marginSides = 120;

    onMount (() => {
        containerWidth = container.clientWidth;
        slideCount = wrapper?.children.length;
    })


    // Next Steps:
    // - have some sort of interaction when swiping beyond the outer bounds instead of just nothingness
    // - disable sideway swiping, when scrolling vertically
    // - make mouse compatible


    // SWIPING
    const velocityMultiplier = 100;
    const x_threshold = 10;
    const y_threshold = 10;
    let direction = undefined;
    let dragging = false;
    let x_start = 0;
    let y_start = 0;
    let x_current = 0;
    let x_previous = 0;
    let x_velocity = 0;

    function handleTouchStart (event) {
        handleStart(event.touches[0].clientX, event.touches[0].clientY)
    }

    function handleMouseDown (event) {
        dragging = true;
        handleStart(event.clientX, event.clientY)
    }

    function handleStart (x, y) {
        direction = undefined;
        x_start = x;
        y_start = y;
        wrapper.style.transition = "none";
    }

    function handleMouseMove (event) {
        if (!dragging) return;
        event.preventDefault(); // prevent text selection
        handleMove (event.clientX, event.clientY, event);  
    }

    function handleTouchMove (event) {
        handleMove (event.touches[0].clientX, event.touches[0].clientY, event);  
    }

    function handleMove (x, y, event) {
        let x_delta = x_start - x;
        let y_delta = y_start - y;
        
        // once were beyond the deadzone decide if we intend to scroll or swipe
        if (direction == undefined){
            if (Math.abs(x_delta) > x_threshold && Math.abs(y_delta) <= y_threshold) {
                direction = 0; //swiping horizontally
                event.preventDefault();
            } else if (Math.abs(y_delta) > y_threshold && Math.abs(x_delta) <= x_threshold) {
                direction = 1; //scrolling vertically
            }
        }
        
        // scrolling vertically
        else if (direction == 1) {
            // were scrolling vertically, so skip all the swiping logic
            return;
        }
        
        // swiping horizontally
        else {
            // prevent vertical scrolling (which is the default behaviour)
            event.preventDefault();
            //prevent swiping further than one slide at a time
            x_current = Math.min(x_delta, containerWidth);
            //set velocity
            x_velocity = x_current - x_previous;
            x_previous = x_current;
            //prevent going further left, than the first slide
            if (activeSlide == 0 && x_current < 0) {
                x_current = -50 * (1 - Math.exp(0.005 * x_current));
            }
            //prevent going further right, than the last slide
            else if (activeSlide == slideCount-1 && x_current > 0) {
                x_current = 50 * (1 - Math.exp(-0.005 * x_current));
            }
        }
        
    }

    function handleMouseUp (event) {
        // If the user swiped, dont propagate MouseUp to children
        if(direction != undefined) {
            event.stopPropagation();
        }
        handleEnd();
        dragging = false;
    }

    function handleEnd () {
        if (x_current + velocityMultiplier * x_velocity > containerWidth/2) {
            nextSlide();
        } else if (x_current + velocityMultiplier * x_velocity < -containerWidth/2) {
            previousSlide();
        }
        x_current = x_previous = x_velocity = 0;
        wrapper.style.transition = "transform 0.3s ease-out";
    }

    function handlePointerCancel(event) {
        event.preventDefault();
        dragging = false;
    }

    // function handleMouseLeave (event) {
    //     event.preventDefault();
    //     dragging = false;
    // }

    function nextSlide () {
        activeSlide += activeSlide<slideCount-1?1:0;
    }

    function previousSlide () {
        activeSlide -= activeSlide>0?1:0;
    }
</script>

<div class="container" style="height: {(containerWidth-marginSides+8)*0.7}px" bind:this={container} bind:clientWidth={containerWidth} on:touchstart={handleTouchStart} on:touchmove={handleTouchMove} on:touchend={handleEnd} on:mousedown={handleMouseDown} on:mousemove={handleMouseMove} on:mouseup|capture={handleMouseUp} on:pointercancel={handlePointerCancel} on:mouseleave={handleMouseUp}>
    <!-- <div class="wrapper" bind:this={wrapper} style="transform: translateX({0.5*marginSides-(containerWidth-marginSides)*activeSlide-x_current}px); width: {(containerWidth-marginSides)*slideCount}px; {x_current? "transition: none;":""}"> -->
    <div class="wrapper" bind:this={wrapper} style="transform: translateX({0.5*marginSides-(containerWidth-marginSides)*activeSlide-x_current}px); width: {(containerWidth-marginSides)*slideCount}px;">
        <slot>
            Slide Slot
        </slot>
    </div>
</div>

<style>
    .container {
        position: relative;
        overflow: hidden;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        cursor: pointer;
    }

    .wrapper {
        position: relative;
        display: flex;
        height: 100%;
        justify-content: space-around;
        /* transition: transform 0.3s ease-out; */
    }

    .pagination {
        position: absolute;
        bottom: 12px;
        left: -16px; /* Offset by width of the active dot, so it's centered */
        right: 0;
        display: flex;
        justify-content: center;
    }

    .dot {
        margin: 4px 4px;
        width: 8px;
        height: 8px;
        background-color: #000;
        opacity: 0.2;
        border-radius: 50%;
    }

    .dot.active {
        margin: 3px 3px;
        width: 10px;
        height: 10px;
        background-color: blue;
        opacity: 1;
        transform: translateX(16px);
        transition: transform 0.2s linear;
        z-index: 1;
    }
</style>